module.exports = __webpack_public_path__ + "img/pic_bt_es.a293c519.png";